import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="gtm"
// Pushes virtual pageview events to GTM dataLayer on Turbo navigations.
// The initial pageview is handled by GTM itself (gtm.js fires on page load).
export default class extends Controller {
  connect() {
    this.initialLoad = true
    this.handleTurboLoad = this.handleTurboLoad.bind(this)
    document.addEventListener("turbo:load", this.handleTurboLoad)
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.handleTurboLoad)
  }

  handleTurboLoad() {
    // Skip the very first page load — GTM handles that automatically via gtm.js
    if (this.initialLoad) {
      this.initialLoad = false
      return
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "page_view",
      page_location: window.location.href,
      page_path: window.location.pathname,
      page_title: document.title
    })
  }
}
